import { Layers } from "lucide-react";
import { useEffect, useState, type MouseEventHandler } from "react";
import { accountRequest, type AccountView } from "./account-api";
export function ProofStudioBrand({
  onClick,
  authenticated,
}: {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  authenticated?: boolean;
}) {
  const [signedIn, setSignedIn] = useState(authenticated === true);
  useEffect(() => {
    if (authenticated !== undefined) {
      setSignedIn(authenticated);
      return;
    }
    let active = true;
    void accountRequest<AccountView>("/status")
      .then((view) => {
        if (active) setSignedIn(!!view.user);
      })
      .catch(() => {
        if (active) setSignedIn(false);
      });
    return () => {
      active = false;
    };
  }, [authenticated]);
  return (
    <a
      className="brand proof-studio-home"
      href={signedIn ? "/#studio?section=projects" : "/welcome"}
      onClick={onClick}
      aria-label="Proof Studio home"
    >
      <span className="brand-mark">
        <Layers size={24} />
      </span>
      <span>
        proof<span className="brand-light">studio</span>
        <small>DOCUMENT WORKSPACE</small>
      </span>
    </a>
  );
}
